import configureStore from "./configureStore"

export const { store, eventSource, dispatchEvent } = configureStore()
export default store